import { Route, Routes } from 'react-router';

import { commonRoutes, redirectRoute } from '@/shared/helpers/routing';

import { useAuthToken } from '../../shared/hooks/useAuthToken';
import { useFeatureFlags } from '../../shared/providers/FeatureFlagProvider';
import { AccountDetails } from './accounts/account-details/account-details';
import { AccountList } from './accounts/account-list/account-list';
import { BillDetailsShad } from './billings/bill-details-shad/bill-details-shad';
import { BillListShad } from './billings/bill-list-shad/bill-list-shad';
import { BillList } from './billings/bill-list/BillList';
import { BillingDetails } from './billings/billing-details/BillingDetails';
import { CarrierDetails } from './carriers/carrier-details/carrier-details';
import { CarrierList } from './carriers/carrier-list/carrier-list';
import { CarrierServiceDetails } from './carriers/carrier-service-details/CarrierServiceDetails';
import { CarrierServiceList } from './carriers/carrier-service-list/carrier-service-list';
import { LocationDetails } from './locations/location-details/location-details';
import { LocationList } from './locations/location-list/location-list';
import { RequestQuote } from './quotes/RequestQuote';
import { ShipmentList } from './shipments/shipment-list/ShipmentList';
import { ShippingPriceDetails } from './shipping-prices/shipping-price-details/ShippingPriceDetails';
import { ShippingPriceList } from './shipping-prices/shipping-price-list/shipping-price-list';
import { CreateScenarioPage } from './simulation/create-scenario-page/create-scenario-page';
import { CreateSimulationPage } from './simulation/create-simulation-page/create-simulation-page';
import { ScenarioDetails } from './simulation/scenario-details/scenario-details';
import { SimulationDetails } from './simulation/simulation-details/simulation-details';
import { SimulationList } from './simulation/simulation-list/simulation-list';

export function PlatformRoutes() {
  const { isInvencoUser } = useAuthToken();
  const { getFeatureFlag } = useFeatureFlags();
  const showSimulation = getFeatureFlag('simulation-ui');

  return (
    <Routes>
      {redirectRoute('/', '/accounts')}

      <Route path="/accounts">
        <Route index element={<AccountList />} />
        <Route path="new" element={<AccountDetails isNew />} />
        <Route path=":id" element={<AccountDetails />} />
      </Route>

      <Route path="/locations">
        <Route index element={<LocationList />} />
        <Route path=":id" element={<LocationDetails />} />
      </Route>

      <Route path="/shipping">
        {redirectRoute('', 'carriers')}
        <Route path="carriers">
          <Route index element={<CarrierList />} />
          <Route path=":id" element={<CarrierDetails />} />
        </Route>

        <Route path="carrier_services">
          <Route index element={<CarrierServiceList />} />
          <Route path=":id" element={<CarrierServiceDetails />} />
        </Route>

        <Route path="prices">
          <Route index element={<ShippingPriceList />} />
          <Route path=":id" element={<ShippingPriceDetails />} />
        </Route>

        <Route path="shipments" element={<ShipmentList />} />
        <Route path="quotes" element={<RequestQuote />} />
      </Route>

      <Route path="/bills">
        <Route index element={<BillList />} />
        <Route path=":id" element={<BillingDetails />} />
      </Route>

      <Route path="/bills-shad">
        <Route index element={<BillListShad />} />
        <Route path=":id" element={<BillDetailsShad />} />
      </Route>

      {showSimulation && (
        <Route path="/simulations">
          <Route index element={<SimulationList />} />
          <Route path="new" element={<CreateSimulationPage />} />
          <Route path=":id">
            <Route index element={<SimulationDetails />} />
            <Route path="scenarios/new" element={<CreateScenarioPage />} />
            <Route path="scenarios/:scenarioId" element={<ScenarioDetails />} />
          </Route>
        </Route>
      )}

      {commonRoutes(isInvencoUser)}
    </Routes>
  );
}
